import schedulerReducer from "./reducers";

export default schedulerReducer;